<div class="container-fluid">
    <div class="row container-categoria-info">
        <div class="col-lg-6 col-sm-12 container-img">
            <!-- <img [src]="imagenContenido" width="100%" alt="categorias"> -->
            <div style="width: 100%; height: 100%; min-height: 50vh;">
                <iframe width="100%" height="100%" style="min-height: 50vh;" [src]="imagenContenido"
                    title="Qué es PowerApps? Aplicación usando EXCEL ONLINE como base da datos!" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="row p-3" *ngIf="modoEdicion">
                <div class="col-12">
                    <input type="text" name="multimedia" id="multimedia" (change)="actualizarImagen(urlYoutube.value)"
                        class="form-control" [value]="imagenContenido" #urlYoutube>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-sm-12 container-info">
            <div>
                <h5>Categorias</h5>
            </div>
            <div class="listCategorias row">
                <div class="col-2 social">
                    <img src="assets/img/icon/social.png" width="100%" alt="Guatemaltecos Ilustres">
                    <span>Social</span>
                </div>
                <div class="col-2 deporte">
                    <img src="assets/img/icon/deporte.png" width="100%" alt="Guatemaltecos Ilustres">
                    <span>Deporte</span>
                </div>
                <div class="col-2">
                    <img src="assets/img/icon/ciencia.png" width="100%" alt="Guatemaltecos Ilustres">
                    <span>Ciencia</span>
                </div>
                <div class="col-2">
                    <img src="assets/img/icon/empresarial.png" width="100%" alt="Guatemaltecos Ilustres">
                    <span>Empresarial</span>
                </div>
                <div class="col-2">
                    <img src="assets/img/icon/arte.png" width="100%" alt="Guatemaltecos Ilustres">
                    <span>Arte</span>
                </div>
            </div>
            <div class="row" *ngIf="modoEdicion">
                <div class="col-12 p-3 text-right" style="text-align: right;">
                    <button class="btn btn-primary ml-2 mr-2" (click)="actualizarContenido()">
                        <svg [cIcon]="icons.cilSave" size="xl" title="Guardar" style="color: white !important;"></svg>
                    </button>
                </div>
                <div class="col-12">
                    <form class="w-100" [formGroup]="formContent">
                        <div class="NgxEditor__Wrapper">
                            <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
                            <ngx-editor [editor]="editor" [placeholder]="'Type here...'"
                                formControlName="contenido"></ngx-editor>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row" *ngIf="!modoEdicion">
                <div class="col-12" [innerHTML]="html">
                </div>
            </div>
            <div>
                <a href="/#/sobre-el-galardon">Conocer más</a>
            </div>
        </div>
    </div>
</div>